export default __webpack_public_path__ + "static/media/stock-campsite.b90c1b73.jpg";